import { DETERMINAR_PAGINA_ATUAL_EMPRESA } from '../types'

export default function determinarPaginaAtualEmpresa (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_EMPRESA,
    payload: paginaAtual
  }
}
